import type { InputMode } from '@brighterly/lib-core-types/ui/inputs/types'

import { getMode } from '@shared/lib/mode'

import { useTutorApplicationStore } from '../store'

interface TeacherRecommendedReturn {
  mode: ComputedRef<InputMode>
  label: string
  setRecommended: (value: boolean) => void
}

export const useTeacherRecommended = (): TeacherRecommendedReturn => {
  const tutorApplicationStore = useTutorApplicationStore()

  const label = 'Current Brighterly teacher recommended to me to apply for this job'

  const mode = computed(() => getMode(tutorApplicationStore.getShowErrors && tutorApplicationStore.getRecommended === null))

  const setRecommended = (value: boolean): void => {
    tutorApplicationStore.setRecommended(value)
  }

  return {
    mode,
    label,
    setRecommended,
  }
}
